import React, { Component } from 'react';
import PerimetreContext from '../../contexts/PerimetreContext';
import { DataCompte } from '../../data/DataCompte.jsx';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxesPerimetreAdministratif } from '../Outils/ComboboxesPerimetreAdministratif';
import { ComboBoxesPerimetreEiffage } from '../Outils/ComboboxesPerimetreEiffage';

export class Perimetre extends Component {

    static contextType = PerimetreContext;

    static defaultState = {
        accesPerimetreEiffage: true, // Détermine quel type de périmètre afficher (Eiffage ou administratif)
    };

    constructor(props) {
        super(props);
        this.state = { ...Perimetre.defaultState };
    };

    _mettreAJourPerimetre = (event, option, index, value, item, perimetre) => {

        //const { onPerimetreChange } = this.props;
        const { accesPerimetreEiffage } = this.state;

        if (accesPerimetreEiffage) {
            const { idRegion, idAgence, idProgramme, idOperation } = perimetre;
            const { setPerimetre } = this.context;
            setPerimetre({ idRegion, idAgence, idProgramme, idOperation }); // Mise à jour de la session et du contexte
            //onPerimetreChange(); // Déclenche la mise à jour du périmètre dans l'élément appelant 'Layout.jsx'
        }
        else {
            const { idRegionAdministrative, idDepartementAdministratif, idVilleAdministrative, idOperation } = perimetre;
            const { setPerimetre } = this.context;
            setPerimetre({ idRegionAdministrative, idDepartementAdministratif, idVilleAdministrative, idOperation }); // Mise à jour de la session et du contexte
            //onPerimetreChange(); // Déclenche la mise à jour du périmètre dans l'élément appelant 'Layout.jsx'
        }

    };

    _chargementDonnees = () => {
        DataCompte._chargementMonCompte().then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const { accesPerimetreEiffage } = responseFetch.reponseAPIobjet;
                const state = { accesPerimetreEiffage };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });
    };

    componentDidMount = () => {
        this._chargementDonnees();
    };

    render = () => {

        const { perimetre } = this.context;
        const { idRegion, idAgence, idProgramme, idRegionAdministrative, idDepartementAdministratif, idVilleAdministrative, idOperation } = perimetre;
        const { accesPerimetreEiffage } = this.state;
        const styles = { root: { padding: "8px" } };

        if (accesPerimetreEiffage)
            return <ComboBoxesPerimetreEiffage
                idAgence={idAgence}
                idOperation={idOperation}
                idProgramme={idProgramme}
                idRegion={idRegion}
                onChange={this._mettreAJourPerimetre}
                styles={styles}
            />;

        else return <ComboBoxesPerimetreAdministratif
            idDepartementAdministratif={idDepartementAdministratif}
            idOperation={idOperation}
            idRegionAdministrative={idRegionAdministrative}
            idVilleAdministrative={idVilleAdministrative}
            onChange={this._mettreAJourPerimetre}
            styles={styles}
        />;

    };

};